import { memo } from 'react';
import { Gauge } from 'lucide-react';
import type { StaffConfidence } from '../../types/staff';
import { confidenceTone } from '../../utils/staffProfile';
import { cn } from '../../utils/cn';

interface StaffConfidenceBadgeProps {
  confidence: StaffConfidence | string;
  /** Hide the "Confidence" prefix in tight spaces (tables, rails). */
  compact?: boolean;
  className?: string;
}

/** Pill for the steward's confidence in a profile (none / low / medium / high). */
export const StaffConfidenceBadge = memo(({ confidence, compact = false, className }: StaffConfidenceBadgeProps) => (
  <span
    className={cn(
      'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold border capitalize whitespace-nowrap',
      confidenceTone(confidence),
      className,
    )}
    title={`Profile confidence: ${confidence || 'none'}`}
  >
    <Gauge className="w-3 h-3" aria-hidden="true" />
    {compact ? confidence || 'none' : `Confidence · ${confidence || 'none'}`}
  </span>
));

StaffConfidenceBadge.displayName = 'StaffConfidenceBadge';
